import React from 'react';
import {
  Box,
  Icongraphy,
  pickColor,
  Text,
  VStack,
} from 'remodeling-web-mobile-sdk-ui';
import styled from 'styled-components';
import { HEADER_HEIGHT } from '@/styles';
import { SearchAddress } from '@remodeling/common';
import use100vh from '@/hooks/use100vh';
import GridInfiniteScroller from '../GridInfiniteScroller';
import SearchZoneCodeResultItem from './SearchZoneCodeResultItem';

interface SearchZoneCodeResultProps {
  totalNum: number;
  list?: SearchAddress[];
  handleReadMore: () => void;
  handleClickAddressItem: (item: SearchAddress) => void;
  handleClose: (id: string) => void;
}

const SearchZoneCodeResult = ({
  totalNum,
  list,
  handleReadMore,
  handleClickAddressItem,
  handleClose,
}: SearchZoneCodeResultProps) => {
  const TOO_MANY_RESULT_NUM = 30;
  const { VH_100 } = use100vh();
  return (
    <>
      <Box
        px={20}
        pb={17}
        borderBottom="1px solid"
        borderBottomColor={pickColor('natural_color.gray.100')}
      >
        <Text
          as="span"
          variant="body2"
          color={pickColor('accent_color.primary.default')}
          mr="4px"
        >
          전체
        </Text>
        <Text
          as="span"
          variant="headline6"
          color={pickColor('accent_color.primary.default')}
        >
          {totalNum}
        </Text>
        <Text
          as="span"
          variant="body2"
          color={pickColor('accent_color.primary.default')}
        >
          건
        </Text>
        {/* 검색 결과가 있고 30개를 넘을 때 */}
        {totalNum >= TOO_MANY_RESULT_NUM && (
          <>
            <Text
              variant="caption1"
              color={pickColor('natural_color.gray.600')}
              mt="8px"
            >
              다음과 같이 검색하시면 정확한 결과가 검색됩니다.
            </Text>
            <Text
              variant="caption1"
              color={pickColor('accent_color.secondary.blue')}
            >
              ‘도로명+건물번호’, ‘지역명+번지’, ‘지역명+건물명(아파트명)
            </Text>
          </>
        )}
      </Box>

      {/* 검색 결과가 있을 때 */}
      {totalNum !== 0 && (
        <ScrollBox totalNum={totalNum} vh100={VH_100}>
          <GridInfiniteScroller<SearchAddress>
            isElement
            columnCount={1}
            list={list || []}
            rowSpace={0}
            handleNextMore={() => handleReadMore()}
          >
            {({ item }) => {
              return (
                <SearchZoneCodeResultItem
                  item={item}
                  key={item.post5No}
                  handleClickAddressItem={handleClickAddressItem}
                  handleClose={handleClose}
                />
              );
            }}
          </GridInfiniteScroller>
        </ScrollBox>
      )}

      {/* 검색 결과가 0건일 때 */}
      {totalNum === 0 && (
        <VStack mt={122}>
          <Icongraphy variant="ic_empty_56" mb={12} />
          <Text
            variant="subTitle2"
            color={pickColor('accent_color.primary.default')}
            mb="8px"
          >
            검색 결과가 없습니다.
          </Text>
          <Text
            variant="body3"
            color={pickColor('natural_color.gray.600')}
            textAlign="center"
          >
            정확한 주소를 확인하시고
            <br />
            다시 한번 검색해 주세요.
          </Text>
        </VStack>
      )}
    </>
  );
};

const ScrollBox = styled(Box)<{ totalNum: number; vh100: number }>`
  height: calc(
    ${(props) => props.vh100} -
      (
        ${(props) => (props.totalNum < 30 ? '139px' : '180px')} +
          ${HEADER_HEIGHT}px
      )
  );
`;

export default SearchZoneCodeResult;
